import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPlugins } from '../../store/AsyncMethods/PluginsMethod';
import { RESET_PLUGINS_MSG } from '../../store/Types/PluginsTypes';
import { toast } from 'react-toastify';

const PLUGIN_META = {
  meta_ads: {
    icon: (
      <svg viewBox="0 0 48 48" className="w-10 h-10" fill="none">
        <rect width="48" height="48" rx="10" fill="#1877F2" />
        <path
          d="M24 8C15.163 8 8 15.163 8 24c0 7.99 5.847 14.614 13.5 15.8V28.5h-4V24h4v-3.2c0-3.948 2.352-6.13 5.953-6.13 1.724 0 3.527.308 3.527.308V18.8h-1.986C26.926 18.8 26 19.956 26 21.13V24h4.5l-.72 4.5H26V39.8C33.653 38.614 40 31.99 40 24c0-8.837-7.163-16-16-16z"
          fill="white"
        />
      </svg>
    ),
    gradient: 'from-blue-500 to-blue-700',
    badge: 'Advertising',
  },
  google_reviews: {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="none">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
    ),
    gradient: 'from-yellow-400 to-red-500',
    badge: 'Social Proof',
  },
  green_api: {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="white">
        <rect width="24" height="24" rx="6" fill="#25D366" />
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="white"/>
      </svg>
    ),
    gradient: 'from-green-400 to-green-600',
    badge: 'WhatsApp',
  },
  google_analytics: {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="none">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
    ),
    gradient: 'from-blue-400 to-orange-500',
    badge: 'Analytics',
  },
  google_search_console: {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="none">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
    ),
    gradient: 'from-green-400 to-blue-500',
    badge: 'SEO',
  },
  email_smtp: {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="none">
        <rect width="24" height="24" rx="6" fill="#EA4335" />
        <path d="M4 7l7.11 4.74a2 2 0 002.22 0L20 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="4" y="6" width="16" height="12" rx="1.5" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    gradient: 'from-red-400 to-red-600',
    badge: 'Email',
  },
  claude_ai: {
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="none">
        <rect width="24" height="24" rx="6" fill="#D97757" />
        <path d="M8 10h.01M12 10h.01M16 10h.01M19 12c0 3.314-3.134 6-7 6a7.7 7.7 0 01-3.1-.64L6 18l1.05-2.8A5.6 5.6 0 015 12c0-3.314 3.134-6 7-6s7 2.686 7 6z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    gradient: 'from-orange-400 to-orange-600',
    badge: 'AI Assistant',
  },
};

export default function PluginsMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { plugins, loading, success, error } = useSelector((s) => s.PluginsReducer);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(getPlugins());
  }, []);

  useEffect(() => {
    if (success) { toast.success(success); dispatch({ type: RESET_PLUGINS_MSG }); }
    if (error) { toast.error(error); dispatch({ type: RESET_PLUGINS_MSG }); }
  }, [success, error]);

  const filtered = (plugins || []).filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    (p.description || '').toLowerCase().includes(search.toLowerCase())
  );

  const openSettings = (pluginKey) => {
    if (pluginKey === 'meta_ads') navigate('/plugins/meta-ads');
    if (pluginKey === 'google_reviews') navigate('/plugins/google-reviews');
    if (pluginKey === 'green_api') navigate('/plugins/green-api');
    if (pluginKey === 'google_analytics') navigate('/plugins/ga4');
    if (pluginKey === 'google_search_console') navigate('/plugins/gsc');
    if (pluginKey === 'email_smtp') navigate('/plugins/email');
    if (pluginKey === 'claude_ai') navigate('/plugins/claude');
  };

  return (
    <div className="mx-3 pb-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Plugins</h1>
          <p className="text-sm text-gray-500 mt-0.5">Connect third-party services and integrations</p>
        </div>
        {/* Search */}
        <div className="relative w-full sm:w-72">
          <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
          </svg>
          <input
            type="text"
            placeholder="Search plugins..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-9 pr-9 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white shadow-sm"
          />
          {search && (
            <button
              onClick={() => setSearch('')}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
              title="Clear search"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Plugin Grid */}
      {loading && !plugins.length ? (
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-20 text-gray-400">
          <svg className="w-12 h-12 mx-auto mb-3 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 0 0-1.022-.547l-2.387-.477a6 6 0 0 0-3.86.517l-.318.158a6 6 0 0 1-3.86.517L6.05 15.21a2 2 0 0 0-1.806.547M8 4h8l-1 1v5.172a2 2 0 0 0 .586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 0 0 9 10.172V5L8 4z" />
          </svg>
          <p className="font-medium">No plugins found</p>
          {search && <p className="text-sm mt-1">Try a different search term</p>}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((plugin) => {
            const meta = PLUGIN_META[plugin.plugin_key] || {};
            return (
              <div
                key={plugin.plugin_key}
                className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-col"
              >
                {/* Card top stripe */}
                <div className={`h-1.5 w-full bg-gradient-to-r ${meta.gradient || 'from-gray-300 to-gray-400'}`} />

                <div className="p-5 flex-1 flex flex-col">
                  <div className="flex items-start justify-between gap-3">
                    <div className="flex items-center gap-3">
                      {meta.icon || (
                        <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                          </svg>
                        </div>
                      )}
                      <div>
                        <h3 className="font-semibold text-gray-800 text-base leading-tight">{plugin.name}</h3>
                        {meta.badge && (
                          <span className="inline-block mt-0.5 text-xs px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 font-medium">
                            {meta.badge}
                          </span>
                        )}
                      </div>
                    </div>
                    {/* Active badge */}
                    <span
                      className={`shrink-0 text-xs font-semibold px-2.5 py-1 rounded-full ${
                        plugin.is_active
                          ? 'bg-green-100 text-green-700'
                          : 'bg-gray-100 text-gray-500'
                      }`}
                    >
                      {plugin.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>

                  <p className="mt-3 text-sm text-gray-500 leading-relaxed flex-1 line-clamp-3">
                    {plugin.description}
                  </p>

                  <button
                    onClick={() => openSettings(plugin.plugin_key)}
                    className="mt-4 w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:border-gray-300 transition-all"
                  >
                    <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <circle cx="12" cy="12" r="3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
                    </svg>
                    Settings
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
